import React from "react";

const TableData = ({ data, tDataClassname }) => {
    return (
        <>
            <tr className={tDataClassname}>
                {data.map((item, index) => {
                    return <td key={index} >{item}</td>;
                })}
            </tr>
        </>
    );
};

export default TableData; 